<template>
  <el-dialog
    :title="dialogTitle"
    :visible.sync="dialogVisible"
    custom-class="page-dialog"
    :close-on-click-modal="false"
    style="margin-top: 130px"
    width="40%"
  >
    <el-dialog
      width="30%"
      title="Add Attributes"
      :visible.sync="innerVisible"
      :close-on-click-modal="false"
      append-to-body>
      <el-select v-model="selectedLabels" placeholder="Please Select" filterable multiple >
        <template  v-for="item in sysLabels">
        <el-option
          v-if="item.disp"
          :key="item.key"
          :label="item.name"
          :value="item.key">
        </el-option>
        </template>
      </el-select>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="afterSelectLabels">OK</el-button>
    </div>
    </el-dialog>
    <div class="system-labels flex-row flex-left">
      <div class="label-title">
        <span>Name：{{ form.FileName }}</span>
      </div>
      <div v-show="flag == -1 || flag == 1" class="label-title">
        <span>Description：</span>
      </div>
      <el-input
        v-show="flag == -1 || flag == 1"
        class="desc-input"
        type="textarea"
        placeholder="Description"
        v-model="form.Description"
        show-word-limit
      >
      </el-input>
      <div v-show="flag == -1 || flag == 2" class="label-title">
        <span>Attributes：</span>
      </div>
      <el-table
        v-show="flag == -1 || flag == 2"
        :data="defaultSysLabels"
        style="width: 100%">
        <el-table-column align="center" label="name" width="140">
          <template slot-scope="{row}">
            <div>{{ row.name }}</div>
          </template>
        </el-table-column>
        <el-table-column align="center" label="value"  width="240">
          <template slot-scope="{row}">
             <el-input v-if="row.type == 1" v-model="row.value" :disabled="!row.write" placeholder="Please input"></el-input>
              <el-date-picker
                v-else-if="row.type == 2"
                v-model="row.value"
                type="datetime"
                :disabled="!row.write"
                :default-value="new Date()"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="Select date and time">
              </el-date-picker>
             <el-input v-else-if="row.type == 3" v-model="row.value" :disabled="!row.write" type="number" placeholder="Please input"></el-input>
          </template>
        </el-table-column>
        <el-table-column
          align="right">
          <template slot="header" slot-scope="scope">
            <el-button
              type="primary"
              icon="el-icon-circle-plus-outline"
              @click="handleSystemAdd">Add</el-button>
          </template>
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="danger"
              @click="handleSystemDelete(scope.$index, scope.row)">Delete</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div v-show="flag == -1 || flag == 3" class="custom-labels flex-row flex-left">
      <div class="label-title">
        <span>Labels：</span>
      </div>
      <div class="custom-content flex-column flex-middle">
        <el-tag
          :key="tag"
          v-for="tag in form.CustomLabels"
          closable
          class="cus-tag"
          :disable-transitions="false"
          @close="handleClose(tag)">
          {{tag}}
        </el-tag>
        <el-input
          class="input-new-tag cus-tag"
          v-if="inputVisible"
          v-model="inputValue"
          ref="saveTagInput"
          size="small"
          @keyup.enter.native="handleInputConfirm"
          @blur="handleInputConfirm"
        >
        </el-input>
        <el-button v-else class="button-new-tag cus-tag" size="small" @click="showInput">+ New Tag</el-button>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="restForm()">Cancel</el-button>
      <el-button type="primary" @click="handleAction()">{{ isAdd ? 'Save':'Save' }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { cloneDeep } from 'lodash'

export default {
  name: 'LabelsDialog',
  props: {
    sysLabels: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data () {
    return {
      dialogVisible: false,
      innerVisible: false, // 内部dialog
      dialogTitle: null,
      flag: -1, // 显示标识 -1 编辑全部 1编辑 Description 2编辑Attributes 3编辑Labels
      isAdd: true,
      form: {
        Description: '', // 描述
        SystemLabels: '{}',
        CustomLabels: '{}'
      },
      selectedLabels: [], // 选中的Attributes
      inputVisible: false,
      inputValue: '',
      userID: '',
      typeList: [
        {
          name: 'String',
          key: 'string',
          id: 1
        },
        {
          name: 'DateTime',
          key: 'datetime',
          id: 2
        },
        {
          name: 'Number',
          key: 'number',
          id: 3
        }
      ],
      defaultSysLabels: [] // 之前设置的Attributes值
    }
  },
  watch: {
    form () {
      console.log('formformform')
      console.log(this.form)
    }
  },
  mounted () {
    this.userID = localStorage.getItem('userID')
  },
  methods: {
    handle (row, flag) {
      this.flag = flag
      if (!row) {
        this.isAdd = true
        console.log('add...')
        this.dialogTitle = 'Add'
      } else {
        this.isAdd = false
        console.log('update...')
        console.log(row)
        this.dialogTitle = 'Edit Labels-' + row.FileName
        const cloneRow = cloneDeep(row)
        if (!cloneRow.SystemLabels) {
          cloneRow.SystemLabels = '{}'
        }
        if (!cloneRow.CustomLabels) {
          cloneRow.CustomLabels = '[]'
        }
        const labelsObj = JSON.parse(cloneRow.SystemLabels)
        const defaultSysLabels = []
        for (let i = 0, len = this.sysLabels.length; i < len; i++) {
          const sysComItem = this.sysLabels[i]
          if (sysComItem.disp && labelsObj[sysComItem.key]) {
            sysComItem.value = labelsObj[sysComItem.key] || ''
            defaultSysLabels.push(sysComItem)
          }
        }
        this.defaultSysLabels = defaultSysLabels
        cloneRow.CustomLabels = JSON.parse(cloneRow.CustomLabels)
        this.form = Object.assign({}, cloneRow)
        this.updateId = row.id
        // this.setForm(row)
      }
      this.dialogVisible = true
    },
    restForm () {
      this.form = {}
      this.dialogVisible = false
    },
    async handleAction () {
      // if (!this.checkInput()) {
      //   return
      // }
      if (this.isAdd) {
        this.handleAdd()
      } else {
        this.handleUpdate()
      }
    },
    // 编辑修改
    handleUpdate () {
      const curSystemLabels = {}
      this.defaultSysLabels.map(item => {
        curSystemLabels[item.key] = item.value
      })
      let param = {
        procID: this.form.ProcID,
        SystemLabels: JSON.stringify(curSystemLabels),
        CustomLabels: JSON.stringify(this.form.CustomLabels),
        Description: this.form.Description
      }
      const loading = this.$loading({
        lock: true,
        text: 'wait a moment ...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      let url = '/kssd/updateLabels'
      const data = this.axios({
        method: 'post',
        url: url,
        data: param,
        headers: {
          UserID: this.userID
        }
      })
      data.then(res => {
        loading.close()
        console.log('res.data:', res.data)
        console.log('res.data.retCode:', res.data.retCode)
        if (res.data.retCode === 0) {
          this.$emit('updateList')
          this.restForm()
          this.$message.success('Save success!')
        } else {
          this.$message.error('fail\n' + res.data.retMsg)
        }
      })
    },

    // #region *******************标签相关******************************** *//
    handleClose (tag) {
      this.form.CustomLabels.splice(this.form.CustomLabels.indexOf(tag), 1)
    },

    showInput () {
      this.inputVisible = true
      this.$nextTick(_ => {
        this.$refs.saveTagInput.$refs.input.focus()
      })
    },

    handleInputConfirm () {
      let inputValue = this.inputValue
      if (inputValue) {
        this.form.CustomLabels.push(inputValue)
      }
      this.inputVisible = false
      this.inputValue = ''
    },
    // #endregion *******************标签相关******************************** *//

    // #region *******************系统标签******************************** *//
    handleSystemDelete (index, row) {
      console.log(index, row)
      this.defaultSysLabels.splice(index, 1)
    },
    handleSystemAdd () {
      this.selectedLabels = this.defaultSysLabels.map(item => item.key)
      this.innerVisible = true
      // if (!this.checkInput()) {
      //   return
      // }
      // this.form.SystemLabels.push({
      //   name: '',
      //   type: 1,
      //   disp: true,
      //   write: true,
      //   value: ''
      // })
    },
    checkInput () {
      const length = this.defaultSysLabels.length
      for (let i = 0; i < length; i++) {
        const element = this.defaultSysLabels[i]
        if (!element.name) {
          this.$message.error(`Please input name on line ${i + 1}!`)
          return false
        } else if (!element.value) {
          this.$message.error(`Please input value on line ${i + 1}!`)
          return false
        }
      }
      return true
    },
    afterSelectLabels () {
      console.log(this.selectedLabels)
      const length = this.selectedLabels.length
      const labels = []
      const sysLabels = cloneDeep(this.sysLabels)
      for (let i = 0; i < length; i++) {
        const selectedKey = this.selectedLabels[i]
        const eleArr = sysLabels.filter(item => item.key === selectedKey)
        const ele = eleArr[0]
        const hadLabels = this.defaultSysLabels.filter(item => item.key === selectedKey)
        if (hadLabels.length > 0) {
          console.log(hadLabels)
          ele.value = hadLabels[0].value
        } else {
          ele.value = ele.default
        }
        labels.push(ele)
      }
      this.defaultSysLabels = labels
      this.innerVisible = false
    }
    // #endregion *******************系统标签******************************** *//

  }
}
</script>

<style scoped>
  .el-tag + .el-tag {
    margin-left: 10px;
  }
  .button-new-tag {
    margin-left: 10px;
    height: 32px;
    line-height: 30px;
    padding-top: 0;
    padding-bottom: 0;
  }
  .input-new-tag {
    width: 90px;
    margin-left: 10px;
    vertical-align: bottom;
  }

  .label-title {
    font-size: 20px;
    font-weight: 400;
    color: #1f2f3d;
  }

  .custom-labels {
    margin-top: 20px;
  }

  .custom-content {
    margin-top: 10px;
  }

  .cus-tag {
    margin-bottom: 10px;
  }

  .desc-input {
    margin-top: 10px;
    margin-bottom: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/labels_dialog.vue